/* eslint-disable max-len */

import XrpQuestion from 'images/coin-pages/questions/xrp.svg'

import { ICoinPageData } from '../types'

export const xrpPage: ICoinPageData = {
  title: 'coin_1193',
  description: 'coin_1194',
  metaTitle: 'xrp_loan_meta_title',
  metaDescription: 'xrp_loan_meta_desc',
  calculatorTitle: 'borrow_against_xrp',
  h1: (t) => (
    <span dangerouslySetInnerHTML={{ __html: t('get_xrp_loan') }} />
  ),
  questionsBlock: {
    image: XrpQuestion,
    questions: [
      {
        title: 'coin_1195',
        answer: 'coin_1196',
      },
      {
        title: 'coin_1197',
        answer: 'coin_1198',
      },
      {
        title: 'coin_1199',
        answer: 'coin_1200',
      },
      {
        title: 'coin_1201',
        answer: 'coin_1202',
      },
    ],
  },
  whatIs: {
    text: [],
    learnMoreTitle: 'learn_more_about_name_lending',
    paragraphs: [
      {
        title: 'coin_1205',
        text: ['coin_1209'],
      },
      {
        title: 'coin_1207',
        text: ['coin_1211', 'coin_1212', 'coin_1213', 'coin_1214'],
      },
      {
        title: 'coin_1208',
        text: ['coin_1215', 'coin_1216', 'coin_1217', 'coin_1218'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/what-is-crypto-lending-platform-coinrabbit/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/07/photo_2021-07-23_20-28-31.jpg',
        imageAlt: 'XRP (XRP) review 5',
      },
      {
        link: 'https://coinrabbit.io/blog/how-crypto-assets-are-secured/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/08/integration-52CR_LQ.png',
        imageAlt: 'XRP (XRP) review 6',
      },
      {
        link: 'https://coinrabbit.io/blog/crypto-lending-growing-market-emerges-opportunities/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2021/05/photo_2021-05-26_21-10-19.jpg',
        imageAlt: 'XRP (XRP) review 7',
      },
    ],
  },
}
